import type { BaseConfig, Constraints } from '~/utils/configTypes'
import { configToQuery, type ProductKey } from '~/utils/configUrl'
import { getConstraints } from '~/config/furnitureConstraints'
import { withLocale, type Locale } from '~/hooks/useLocale'

// Canonical shareable configurator link. withLocale keeps the default locale
// (ro) unprefixed — a hardcoded `/${locale}/` here used to mint /ro/... dupes.
export function buildConfigShareUrl(
  config: BaseConfig,
  product: ProductKey,
  locale: Locale
): string {
  const constraints = getConstraints(product) as Constraints
  const queryParams = configToQuery(config, product, constraints)
  const searchParams = new URLSearchParams()
  Object.entries(queryParams).forEach(([key, value]) => {
    searchParams.set(key, String(value))
  })
  const queryString = searchParams.toString()
  const origin =
    typeof window !== 'undefined' ? window.location.origin : ''
  const base = `${origin}${withLocale(`/configurator/${product}`, locale)}`
  return queryString ? `${base}?${queryString}` : base
}
